<template lang="pug">
.footer-pegi
  .footer-pegi__text {{ age }}
</template>
<script>
export default {
  name: "FooterPegi",
  props: {
    age: {
      type: String,
      default: "16+",
    },
  },
}
</script>